export default __webpack_public_path__ + "static/image2-6b6aeb7408dbc1d65af3f2fd2c2ebdf6.gif";